import styled from 'styled-components/macro';
import {themecolors} from "../utils/themecolors";

const Footer = styled(({className}) => (
    <footer className={className} />
))`
  flex-direction: column;
  padding: 24px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
`;

export default Footer;
